/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, { useState, useEffect } from 'react';
import {ButtonToolbar, Col, Row} from 'react-bootstrap';
import {validated} from 'react-custom-validation';
import Helmet from 'react-helmet';

import $ from 'jquery';

import BlueButton from '@corero/ssp-ui-components/components/buttons/BlueButton/BlueButton';
import SimpleButton from '@corero/ssp-ui-components/components/buttons/SimpleButton/SimpleButton';
import Input from '@corero/ssp-ui-components/components/form/input/Input';

import sharedConfig from '@corero/ssp-ui-components/core/sharedConfig';
import validationRules from '@corero/ssp-ui-components/core/validation';

import {actions as themeActions, store as themeStore} from "@corero/ssp-ui-components/stores/AppConfigStore"
import {store} from '@corero/ssp-ui-components/stores/AuthStore';

import withRouter from '@corero/ssp-ui-components/utils/withRouter';

import './forgotPassword.scss';

const ForgotPassword = (props) => {
    const { router } = props;

    const [email, setEmail] = useState('');
    const [themeConfiguration, setThemeConfiguration] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);

    const onThemeConfigChange = () => {
        const themeConfig = themeStore.getThemeConfiguration();
        setThemeConfiguration({
            loginColorButton: themeConfig.login_color_button,
            loginColorErrorText: themeConfig.login_color_error_text,
            loginColorBtnForeground: themeConfig.login_color_btn_foreground,
            loginColorCancelBtn: themeConfig.login_color_cancel_btn,
            loginColorCancelBtnForeground: themeConfig.login_color_cancel_btn_foreground,
            loginButtonBorderColor: themeConfig.login_button_border_color,
            loginButtonBorderWidth: themeConfig.login_button_border_width,
        });
    }

    useEffect(() => {
        $("body").addClass("forgot-password-page");
        $(".forgot-password-page").css("background-image", "url(" + sharedConfig.apis.theme + "/backgroundImage)");

        themeStore.addChangeListener(onThemeConfigChange);

        themeActions.fetchThemeConfiguration();

        return () => {
            $("body").removeClass("forgot-password-page");
            $('.forgot-password-page').css('background-image', '');
            $(".error-message").css('color', 'red');
            $(".footer-cr").css('color', '')

            themeStore.removeChangeListener(onThemeConfigChange)
        }
    }, []);

    const cancel = () => {
        router.navigate('/login');
    };

    const submit = () => {
        store.sendPasswordResetEmail({
            email,
            callback: () => {
                router.navigate('/login/apply-token')
            }
        });
        setIsDisabled(true);
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-inner-container">
                <Helmet defer={false} title="Forgot Password" />
                <Row>
                    <Col sm={12}>
                        <h1 style={{ color : themeConfiguration.loginColorText }} className="text-center">Password Reset</h1>
                        <p style={{ color : themeConfiguration.loginColorText }} className="password-info mt40">
                            Enter your username and press the Send Token button. A Password Reset Token will be sent to you via email.
                        </p>

                        <Row className="mt20">
                            <Col sm={{span: 4, offset: 4}}>
                                <ValidatedForm
                                    fields={{email}}
                                    themeConfiguration={themeConfiguration}
                                    onCancel={cancel}
                                    onEmailChange={setEmail}
                                    onValid={submit}
                                    isDisabled={isDisabled}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

const Form = (props) => {
    const {$field, $validation, $submit, themeConfiguration, onValid, onInvalid, onCancel, onEmailChange, isDisabled} = props;
    const fields = { $field, $validation, fields: props.fields };
    return (
        <form onSubmit={(e) => { e.preventDefault(); $submit(onValid, onInvalid) }}>
            <Input
                errorColor={themeConfiguration.loginColorErrorText}
                type="text"
                name="email"
                placeholder="Username"
                fieldSizes={{ xs: 12 }}
                onChange={(_name, value) => onEmailChange(value)}
                {...fields}
            />
            <ButtonToolbar>
                <SimpleButton
                    style={{
                        background : themeConfiguration.loginColorCancelBtn,
                        border: "none", color: themeConfiguration.loginColorCancelBtnForeground
                    }}
                    title="Cancel"
                    click={(e) => {
                        e.preventDefault();
                        onCancel();
                    }} />
                <BlueButton
                    style={{
                        background : themeConfiguration.loginColorButton,
                        color: themeConfiguration.loginColorBtnForeground,
                        border: !Number.isNaN(themeConfiguration.loginButtonBorderWidth) && themeConfiguration.loginButtonBorderColor ?
                            `${themeConfiguration.loginButtonBorderWidth}px solid ${themeConfiguration.loginButtonBorderColor}` :
                            "none"
                    }}
                    title="Send Token"
                    isDisabled={isDisabled} />
            </ButtonToolbar>
        </form>
    );
}

const ValidatedForm = validated(validationConfig)(Form);

function validationConfig(props) {
    const { email } = props.fields;
    const validations = {
        email: [[validationRules.required, email], [validationRules.isEmail, email]]
    };
    return {
        fields: ['email'],
        validations: validations
    }
}

export default withRouter(ForgotPassword);
